var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('Gis-Map')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right_title"},[_c('div',{staticClass:"bj"},[_c('span',[_vm._v("快捷导航")])])])}]

export { render, staticRenderFns }